import React from 'react';
import { Avatar, Dropdown, message } from 'antd';
import { useTypedDispatch, useTypedSelector } from '@/store';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { logOut } from '@/store/user/thunkActions';

import { type MenuInfo } from 'rc-menu/lib/interface';

const UserAvatar = () => {
  const [t] = useTranslation();
  const history = useNavigate();
  const dispatch = useTypedDispatch();

  const user = useTypedSelector(state => state.authUser.user);

  const onLogout = async () => {
    try {
      await dispatch(logOut());
    } catch (e: any) {
      message.error(
        <div>
          <h3>Error while logging out</h3>
          <p>{e.message}</p>
        </div>,
        4
      );
    }
  };

  const onItemClick = (event: MenuInfo) => {
    switch (event.key) {
      case 'settings':
        history('/settings/account-details');
        break;
      case 'logout':
        onLogout();
        break;
      default:
        break;
    }
  };

  const items = [
    {
        key: "settings",
        label: <div className="user-avatar__item">{t("settings")}</div>,
    },
    {
        key: "logout",
        label: (
            <div className="user-avatar__item user-avatar__item--logout">
                {t("logout")}
            </div>
        ),
    },
  ];

  return (
    <Dropdown trigger={['click']} menu={{ items, onClick: onItemClick }}>
      <Avatar src={user.logo?.path} size="large" />
    </Dropdown>
  );
};

export default UserAvatar;
